import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = () => {
    return (
        <div className="loading-container">
            <div className="spinner"></div>
            <p>Chargement en cours...</p>
        </div>
    );
};

export default LoadingSpinner;
